import React, { useContext } from 'react';
import { Box, IconButton, Center, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { MdOutlineShoppingCart } from 'react-icons/md';

import { CartContext } from '@rsc/contexts';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

const animation = keyframes`
  0% { transform: scale(1.02); }
  20% { transform: scale(1.1); }
  40% { transform: scale(1.3); }
  60% { transform: scale(1.1); }
  80% { transform: scale(1.02); }
  100% { transform: scale(1); }
`;

export default function NavCartButton() {
  const grow = `${animation} ease-in-out 1s`;
  const { cart, cartActive, cartBusy, setCartActive } = useContext(CartContext);
  const { tt } = useUiComponentsInternationalContext();

  const cartCount = cart?.totalQuantity;

  return (
    <Box
      as="button"
      pos="relative"
      aria-label={tt(s => s.navCartButtonComponent.shoppingCartAriaLabel)}
      onClick={e => {
        e.preventDefault();
        setCartActive(!cartActive);
      }}
    >
      <IconButton
        as="div"
        icon={<MdOutlineShoppingCart size={24} />}
        variant="nav"
        color="typography.lighter"
        animation={cartBusy ? grow : ''}
      />
      {cartCount ? (
        <Center
          background="brand.sunny"
          borderRadius="full"
          p="1"
          pos="absolute"
          top="3"
          right="0"
          w="4"
          h="4"
          cursor="pointer"
        >
          <Text fontSize="10px" lineHeight="10px" pos="relative" top="1px">
            {cartCount}
          </Text>
        </Center>
      ) : null}
    </Box>
  );
}
